import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import {IReduxUserState} from '../../src/@interfaces';
import {Navigate} from 'react-router-dom';
import EmptyLayout from '../../src/components/_layouts/Empty/EmptyLayout';

export default class AuthLogout extends AbstractView<IReduxUserState & {
    clearUserRequisites(): void,
}> {
    static layout = EmptyLayout;
    protected static pageTitle = 'AuthLogout.page-title';

    protected authorize(): boolean {
        return Boolean(this.props.model);
    }

    componentDidMount() {
        this.props.clearUserRequisites();
    }

    protected renderContent(): React.ReactNode {
        return <Navigate to="/" replace={true}/>;
    }

    render() {
        return this.renderContent() as JSX.Element;
    }
}
